import { AbstractControl, ValidationErrors } from '@angular/forms';

export const maxSelectionValidator = (max: number) => {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value ?? [];
    return value.length > max ? { maxSelection: { actual: value.length, max } } : null;
  };
};
